import React from "react";
import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import PersonIcon from '@mui/icons-material/Person';
import "@fontsource/montserrat";
import { FaFacebook, FaInstagram } from "react-icons/fa";


const Footer = ({selected, setSelected}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  // const [selected, setSelected] = useState(0);
  const isMobile = useMediaQuery("(max-width:1020px)");
  const menuItems = [
    { label: "Про нас", path: "/aboutUs" },
    { label: "Сертифікатні програми", path: "/courses" },
    { label: "Підготовчі курси до НМ", path: "/entranceCourses" },
    // { label: "Вебінари", path: "/webinars" },
    // { label: "Кваліфікаційні центри", path: "/qualification-centers" },
    { label: "Викладачі", path: "/allTeachersPage" },
    // { label: "Партнери", path: "/partners" },
    // { label: "Новини", path: "/news" },
  ];

  const onClick = (index, path) => {
    setSelected(index);
    localStorage.setItem("currentPage", 1);
    navigate(path);
  }

  return (
    <Box sx={{ 
      width: "100%", 
      backgroundColor: theme.palette.background.paper, 
      color: theme.palette.text.primary,
      padding: "20px 0", 
      textAlign: "center",
      bottom: 0,
      left: 0,
      right: 0,
      mt: 'auto',
      }}>
      {isMobile ? (
      //Мобільна версія
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
      {/* Вехрній бокс */}
      <Box sx={{ display: "flex",justifyContent:"space-evenly", alignItems: "flex-start", flexDirection: "row", width:"100%", marginRight:"30px" }}>
      {/* Логотип */}
      <Box
        component="img"
        src={theme.brand.logo}
        alt={theme.brand.logoAlt}
        height="88px"
        sx={{ cursor: "pointer"}}
        onClick={() => navigate("/")}
      />
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 1 }}>
        <Box>
          <Button
            variant="outlined"
            startIcon={<PersonIcon />}
            onClick={() => navigate("/login")}
            sx={{
              textTransform: "none",
              fontSize: "14px",
              borderColor: theme.palette.primary.dark,
              borderRadius: 0,
              color: theme.palette.primary.dark,
              padding: "5px 12px",
              "&:hover": { backgroundColor: theme.palette.background.paper, borderColor: theme.palette.primary.dark },
            }}
          >
            Увійти
          </Button>
          </Box>
          <Box sx={{ display: "flex"}}>
              <Button variant="text" sx={{ color: theme.palette.text.primary, minWidth:'auto', p: 0}} href="https://www.facebook.com/nubip.edu.ua/" target="_blank">
                <FacebookIcon sx={{ fontSize: 28 }} />
              </Button>
              <Button variant="text" sx={{ color: theme.palette.text.primary, minWidth:'auto', p: 0, ml: 0.5}} href="https://www.instagram.com/nubip.1898/" target="_blank">
                <InstagramIcon sx={{ fontSize: 28 }} />
              </Button>
          </Box>
        </Box>
      </Box>
      {/* Середній бокс */}
      <Box sx={{ display: "flex", flexDirection: "row",justifyContent:"space-around", alignItems: "center", gap: 1, flexWrap: "wrap", width:"80%", marginTop:"5%"}}>

  {/* Перша колонка з усіма кнопками, крім останніх двох */}
  <Box
  sx={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr", // Дві колонки
    gap: 1, // Відступ між елементами
    alignItems: "flex-start",
  }}
>
  {/* Перша колонка з усіма кнопками, крім останніх двох */}
  <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
    {menuItems.slice(0, -2).map((item, index) => (
      <Button
        key={item.label}
        variant="text"
        sx={{
          fontFamily: "Montserrat",
          fontSize: "14px",
          color: theme.palette.text.primary,
          paddingRight: "18px",
          borderRadius: 0,
          fontWeight: selected === index ? "bold" : "normal",
          textTransform: "capitalize", // Перша літера велика, решта — маленькі
          justifyContent: "flex-start", // Вирівнювання тексту по лівому краю
          "&:hover": { color: theme.palette.text.primary },
          textAlign:'left'
        }}
        onClick={() => onClick(index, item.path)}
      >
        {item.label}
      </Button>
    ))}
  </Box>

  {/* Друга колонка з останніми двома кнопками */}
  <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
    {menuItems.slice(-2).map((item, index) => (
      <Button
        key={item.label}
        variant="text"
        sx={{
          fontFamily: "Montserrat",
          fontSize: "14px",
          color: theme.palette.text.primary,
          paddingRight: "18px",
          borderRadius: 0,
          fontWeight: selected === menuItems.length - 2 + index ? "bold" : "normal",
          textTransform: "capitalize", 
          justifyContent: "flex-start", 
          "&:hover": { color: theme.palette.text.primary },
          textAlign:'left'
        }}
        onClick={() => {
          setSelected(menuItems.length - 2 + index);
          navigate(item.path);
        }}
      >
        {item.label}
      </Button>
    ))}
  </Box>
</Box>
</Box>

      {/* Нижній бокс */}
      <Box sx={{ mt: 1, fontSize: "12px",width:"80%" }}>
        <Button
          onClick={() => navigate("/public-offer")}
          sx={{
            fontFamily: "Montserrat",
            fontSize: "14px",
            height: "10px",
            borderRadius: 0,
            color: theme.palette.text.secondary,
            textTransform: "none",
            "&:hover": { textDecoration: "underline" },
            textAlign:'left'
          }}
        >
          Договір публічної оферти
        </Button>
        <Button
          onClick={() => navigate("/privacy-policy")}
          sx={{
            fontFamily: "Montserrat",
            fontSize: "14px",
            color: theme.palette.text.secondary,
            textTransform: "none",
            "&:hover": { textDecoration: "underline" },
          }}
        >
          Політика конфіденційності
        </Button>
      </Box>
      </Box>
      ) : (
        //Десктопна версія
        <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderTop: `1px solid ${theme.palette.divider}`,
        p: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Montserrat",
      }}
    >

      <Box
        sx={{
          display: "flex",
          width: "100%",
          maxWidth:'1300px',
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        {/* Логотип */}
        <Box
          component="img"
          src={theme.brand.logo}
          alt={theme.brand.logoAlt}
          height="88px"
          sx={{ cursor: "pointer", paddingLeft:'40px'}}
          onClick={() => navigate("/")}
        />

        {/* Меню */}
        <Box>
        <Box sx={{ display: "flex", gap: 2 }}>
      {menuItems.map((item, index) => (
        <Button
          key={item.label}
          variant="text"
          sx={{
            fontFamily: "Montserrat",
            fontSize: "14px",
            color: theme.palette.text.primary,
            paddingRight: "18px",
            borderRight: item.label !== "Новини" ? `1px solid ${theme.palette.divider}` : "none",
            borderRadius: 0,
            fontWeight: selected === index ? "bold" : "normal",
            "&:hover": { color: theme.palette.text.primary },
            
          }}
          onClick={() => onClick(index, item.path)}
        >
          {item.label}
        </Button>
      ))}
    </Box>

        {/* Нижні посилання */}
      <Box sx={{ textAlign: "left", mt: 1, fontSize: "12px" }}>
        <Button
          onClick={() => navigate("/publicOfferAgreement")}
          sx={{
            fontFamily: "Montserrat",
            fontSize: "12px",
            borderRight: `1px solid ${theme.palette.divider}`,
            height: "10px",
            borderRadius: 0,
            color: theme.palette.text.secondary,
            textTransform: "none",
            "&:hover": { textDecoration: "underline" },
          }}
        >
          Договір публічної оферти
        </Button>
        <Button
          onClick={() => navigate("/privacyPolicy")}
          sx={{
            fontFamily: "Montserrat",
            fontSize: "12px",
            color: theme.palette.text.secondary,
            textTransform: "none",
            "&:hover": { textDecoration: "underline" },
          }}
        >
          Політика конфіденційності
        </Button>
      </Box>
        </Box>

        {/* Кнопка "Увійти" + соцмережі */}
        <Box sx={{ display: "flex", flexDirection:"column", alignItems: "center", gap: 2}}>
          <Box>
          <Button
            variant="outlined"
            startIcon={<PersonIcon />}
            onClick={() => navigate("/login")}
            sx={{
              textTransform: "none",
              fontSize: "14px",
              borderRadius: 0,
              borderColor: theme.palette.primary.dark,
              color: theme.palette.primary.dark,
              padding: "5px 12px",
              "&:hover": { backgroundColor: theme.palette.background.paper, borderColor: theme.palette.primary.dark },
            }}
          >
            Увійти
          </Button>
          </Box>
          <Box sx={{ display: "flex"}}>
              <Button variant="text" sx={{ color: theme.palette.text.primary, ":hover":{ color: theme.palette.social.fb, background: 'transparent'} }} href="https://www.facebook.com/nubip.edu.ua/" target="_blank">
                <FaFacebook size={25} />
              </Button>
              <Button variant="text" sx={{ color: theme.palette.text.primary, ":hover":{ color: theme.palette.social.insta, background: 'transparent'} }} href="https://www.instagram.com/nubip.1898/" target="_blank">
                <FaInstagram size={25} />
              </Button>
          </Box>
        </Box>
      </Box>
    </Box>
      )
      }
    </Box>
  );
};

export default Footer;